// Module
var code = "<div class=\"block height-100\"> <h2>[Admin] Copy PG from Mongo</h2> Nothing to do; the page just calls the API </div> ";
// Exports
export default code;